<template>
  <v-app>
    <header class="header">
      <UserInfo class="user-info-container" v-if="$route.path === '/profile'"/>
      <div v-else>
      </div>
      <a href="https://www.stokecityfc.com/">
        <img src="./assets/logo.jpg" height="98" width="84" class="logo" />
      </a>
      
      <div class="mini-nav" v-if="ticketingRedirect">
        <ul v-if="miniNavTicketingEnabled">
          <li><a v-on:click="redirectToTicketing()" class="web-link">Return to Ticketing</a></li>
        </ul>
      </div>
      <div class="mini-nav" v-else-if="$route.path === '/profile' && appLogin === false">
        <ul>
          Stoke City Official Websites
          <li><a href="https://www.stokecityfc.com/" class="web-link">Official website</a></li>
          <li><a href="https://store.stokecityfc.com/" class="web-link">Online store</a></li>
          <li><a href="https://tickets.stokecityfc.com/" class="web-link">Ticketing</a></li>
          <li><a href="https://stokefcpayments.streamamg.com/account/" class="web-link">Stoke City+ Live</a></li>
        </ul>
      </div>
      <div v-else>
      </div>
    </header>
    
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Vue from 'vue'
//import Vuetify from 'vuetify'
import CognitoPlugin from './cognito-plugin.js'
import VueCookie from 'vue-cookie'
import UserInfo from '@/components/UserInfo'

import Vuetify, {
  VApp, // required
  VAlert,
  VTabs,
} from 'vuetify/lib'

import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  components: {
    VApp,
    VAlert,
    VTabs,
  },
  directives: {
    Ripple
  }
})

Vue.use(CognitoPlugin)
Vue.use(VueCookie)
Vue.use(require('vue-moment'));

export default {
  name: 'App',
  components: {
    UserInfo
  },
  data () {
    return {
      loggedIn: false,
      referrer: null,
      appLogin: false,
      ticketingRedirect: null,
      miniNavTicketingEnabled: false,
      trusted: ['stokefcpayments.streamamg.com', 'stokecityfc.com', 'retailsportssystems.com']
    }
  },
  mounted () {
    console.log(window.location.href)
    if(localStorage.appLogin === 'true'){
      this.appLogin = true
    }

    // simple referral tracking (deprecated)
    if(window.location.href.includes("referred=1")){ //if the user is referred from a partner site
      localStorage.referrer = document.referrer
    }

    var urlPieces = window.location.href.split("returnUrl=") 
    // JWT return tracking from trusted Domains


    if(window.location.href.includes("returnUrl=")) { //if the user is referred from the StreamAMG payments site
      
      console.log('returnUrl requested')
      var trustedSource = false
      this.trusted.forEach(domain => {
        if(urlPieces[1].includes(domain)){
          trustedSource = true
          console.log(domain, 'is trusted')
        } 
      });
      
      if(trustedSource === true) {
        console.log('Trusted returnUrl set', window.location.href)
        localStorage.returnUrl = decodeURIComponent(urlPieces[1])
        if(window.location.href.includes("sendToken=false")){
          localStorage.suppressToken = "true"
        } else {
          localStorage.removeItem('suppressToken');
        }
      } else {
        console.log('returnUrl NOT from trusted domain')
      }
    } else {
      console.log('returnUrl NOT requested')
    }

    if(typeof localStorage.returnUrl != 'undefined'){
      if(localStorage.returnUrl.includes('ticket')){
        this.ticketingRedirect = localStorage.returnUrl
      }
    }
    //Upon initial mount we check the authentication state
    console.log('Access Check', 'route change')
      if(this.$getAuthenticatedUser() != null) {
        console.log('Access Check', 'user authenticated')
        this.$getCurrentUserAttributes().subscribe((userData) => {
          //check if the user has completed their registration (mostly this will be Social Media Registrations, post linking of their account)
          console.log('Access Check', 'checking registration is complete')
          // console.log('Access Check userDate', userData)
          
          if(userData['custom:privacy_accepted'] === 'true'){
            console.log('Access Check', 'privacy accepted')
            this.loggedIn = true;
            //always force logged in users to their profile, unless they are already going there
            this.$router.push("/profile");
            
          }else{
            console.log('Access Check', 'privacy NOT previously accepted')
            this.loggedIn = false;
            this.$router.push("/complete-registration");
          }
        }, 
        (err)=> {
          console.log('Access Check', 'Unable to load user profile, session may not be present.')
          this.loggedIn = false;
        });
      
      } else {
        console.log('Access Check', 'no authenticated user present')
        this.loggedIn = false;
      } 
    
    
  },
  methods: {
    redirectToTicketing (){
      var redirectTo = localStorage.returnUrl
      localStorage.returnUrl = ''
      window.location = redirectTo
    }
  },
  
  watch: {
    '$route' (to) {
      //Upon each route change we check the authentication state
      
      if(localStorage.appLogin === 'true'){
        this.appLogin = true
      }

      console.log('Access Check', 'route change')
      if(this.$getAuthenticatedUser() != null) {
        console.log('Access Check', 'user authenticated')
        this.$getCurrentUserAttributes().subscribe((userData) => {
          //check if the user has completed their registration (mostly this will be Social Media Registrations, post linking of their account)
          console.log('Access Check', 'checking registration is complete')
          // console.log('Access Check userDate', userData)
          
          if(userData['custom:privacy_accepted'] === 'true'){
            console.log('Access Check', 'privacy accepted')
            // tell the app that we've finished loading
            if(to.path!='/profile'){
              this.loggedIn = true;
              //always force logged in users to their profile, unless they are already going there
              this.$router.push("/profile");
            }
          }else{
            console.log('Access Check', 'privacy NOT previously accepted')
            this.loggedIn = false;
            this.$router.push("/complete-registration");
          }
        }, 
        (err)=> {
          console.log('Access Check', 'Unable to load user profile, session may not be present.')
          this.loggedIn = false;
        });
      
      } else {
        console.log('Access Check', 'no authenticated user present')
        this.loggedIn = false;
      }
    }
  }
}
</script>

<style lang="scss">
  @import '/css/global.scss';
</style>

<style lang="scss" scoped>
    .header {
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    padding: 20px 20px 0;
    margin: 0 0 35px;
  }

  .user-info-container {
    margin: 20px 0 0;
  }

  .button-home {
    display: none;
  }

  @media screen and (min-width: 700px) {
    .header {
      flex-direction: row;
      justify-content: space-between;
      padding: 48px 100px 48px;
    }

    .user-info-container {
      top: 43px;
      left: 20px;
      margin: 0;
    }
    .logo{
      margin-left: -90px;
    }

    .button-home {
      display: block;
    }
  }

  @media screen and (min-width: 700px) {
    .header {
      padding: 48px 300px 48px;
    }
  }
  .mini-nav{
    width:250px;
  }
  .mini-nav li{
    list-style: none
  } 
  .web-link{
      padding: 0;
      margin: 0 2px 0 0;
      color: #D7172F;
      font-size: 12px;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
  }
  .page-title{
    color: #D7172F;
      font-size: 44px;
    text-align: left;
  }
</style>
